module.exports = __webpack_public_path__ + "static/img/wzry-logo.65834afe.png";